// extracted by mini-css-extract-plugin
module.exports = {"tick":"_b25b75d","close":"_0cc981f"};